import NextImage, { ImageProps as NextImageProps } from 'next/image';
import { FC } from 'react';

export interface ImageProps extends NextImageProps {}

// Lazy by default (Next.js): images below the first screen load only when scrolled to.
// Pass `priority` for the main first-screen image, or `loading="eager"` where lazy loading is unwanted.
const Image: FC<ImageProps> = (props) => {
  return <NextImage {...props} />;
};

export default Image;
